import { render, staticRenderFns } from "./project-identification.html?vue&type=template&id=c4bb664c&"
import script from "./ProjectIdentification.vue?vue&type=script&lang=js&"
export * from "./ProjectIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports